import { $apiPrivate, $apiPublic } from "Api";

const PROJECT_PATH = "/projects";
const COUNT_ALL_PATH = "/count";
const PROJECT_FINISH_PATH = "/finish/";
const CREATE_PROJECT_PATH = "/create";
const STATUSES_PROJECT_PATH = "/statuses";
const UPDATE_PROJECT_PATH = "/update";
const UPDATE_MATERIALS_PROJECT_PATH = "/update/materials";
const GET_ALL_PROJECT_PATH = "/all";
const GET_MY_PROJECT_PATH = "/my";
const GET_WORKS_FOR_TABLE_PROJECT_PATH = "/table";
const CREATE_BLANK_PROJECT_PATH = "/blank";
const GET_PROJECT_INFO_PATH = "/get/";
const GET_BLANKS_FOR_MONTH_PROJECT_PATH = "/blank/month/";
const GET_SINGLE_BLANK_PROJECT_PATH = "/blank/single/";
const UPDATE_BLANK_PROJECT_PATH = "/blank/update";
const SEND_BLANK_PROJECT_PATH = "/blank/send";
const SEND_BLANKBACK_PROJECT_PATH = "/blank/sendback";
const SEND_BLANK_DONE_PROJECT_PATH = "/blank/done";
const SEND_ESTIMATE_FILE_PROJECT_PATH = "/upload/estimator";
const GET_SAVED_BLANKS_PATH = "/blank/getsaved";
const DELETE_SAVED_BLANK_PATH = "/blank/deletesaved";
const SAVE_BLANK_WEB_PATH = "/blank/saveblank";
const GET_ALL_MATERIALS_BLANK = "/blank/materials";
const GET_TABLE_MATERIALS_PROJECT_PATH = "/project/tablematerials";
const DELETE_BLANK_PROJECT_PATH = "/blank/deletepermanently";
const GET_LAST_USERS_BLANK_PROJECT_PATH = "/blank/getlastusers";
class ProjectApi {
  saveBlankWeb = async (data) => {
    return await $apiPrivate.post(PROJECT_PATH + SAVE_BLANK_WEB_PATH, {
      ...data,
    });
  };
  createNewProject = async (data) => {
    return await $apiPrivate.post(PROJECT_PATH + CREATE_PROJECT_PATH, {
      ...data,
    });
  };
  updateProject = async (data) => {
    return await $apiPrivate.post(PROJECT_PATH + UPDATE_PROJECT_PATH, {
      ...data,
    });
  };
  updateProjectMaterials = async (data) => {
    return await $apiPrivate.post(
      PROJECT_PATH + UPDATE_MATERIALS_PROJECT_PATH,
      {
        ...data,
      },
    );
  };
  getAllStatuses = async () => {
    return await $apiPrivate.get(PROJECT_PATH + STATUSES_PROJECT_PATH);
  };
  getMyProjects = async (page = 1, searchValue = "", limit = 10) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_MY_PROJECT_PATH +
        `?page=${page}&search=${searchValue}&limit=${limit}`,
    );
  };
  getAllProjects = async (
    page = 1,
    searchValue,
    ingeneerIdArray = [],
    limit = 10,
  ) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_ALL_PROJECT_PATH +
        `?page=${page}&search=${searchValue}&limit=${limit}&users=${ingeneerIdArray.join(",")}`,
    );
  };
  getProject = async (projectId) => {
    return await $apiPrivate.get(
      PROJECT_PATH + GET_PROJECT_INFO_PATH + projectId,
    );
  };
  setFinish = async (projectId) => {
    return await $apiPrivate.post(
      PROJECT_PATH + PROJECT_FINISH_PATH + projectId,
    );
  };
  createBlank = async (data) => {
    return await $apiPrivate.post(PROJECT_PATH + CREATE_BLANK_PROJECT_PATH, {
      ...data,
    });
  };
  updateBlank = async (data) => {
    return await $apiPrivate.post(PROJECT_PATH + UPDATE_BLANK_PROJECT_PATH, {
      ...data,
    });
  };
  getBlanks = async (month, projectId) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_BLANKS_FOR_MONTH_PROJECT_PATH +
        `?projectId=${projectId}&monthNumber=${month}`,
    );
  };
  getSingleBlank = async (projectId, blankId) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_SINGLE_BLANK_PROJECT_PATH +
        `?projectId=${projectId}&blankId=${blankId}`,
    );
  };
  sendBlank = async (blankId, projectId) => {
    return await $apiPrivate.post(
      PROJECT_PATH +
        SEND_BLANK_PROJECT_PATH +
        `?blankId=${blankId}&projectId=${projectId}`,
    );
  };
  getWorksForProject = async (projectId) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_WORKS_FOR_TABLE_PROJECT_PATH +
        `?projectId=${projectId}`,
    );
  };
  getInfoAboutMyProjects = async () => {
    return await $apiPrivate.get(PROJECT_PATH + COUNT_ALL_PATH);
  };
  postEstimateFileWorks = async (formData) => {
    return await $apiPrivate.post(
      PROJECT_PATH + SEND_ESTIMATE_FILE_PROJECT_PATH,
      formData,
    );
  };
  getSavedBlanksForProject = async (projectId) => {
    return await $apiPrivate.get(
      PROJECT_PATH + GET_SAVED_BLANKS_PATH + `?projectId=${projectId}`,
    );
  };
  deleteSavedBlankForProject = async (blankId, projectId) => {
    return await $apiPrivate.delete(
      PROJECT_PATH +
        DELETE_SAVED_BLANK_PATH +
        `?blankId=${blankId}&projectId=${projectId}`,
    );
  };
  sendBackBlank = async ({ blankId, emailToken }) => {
    return await $apiPublic.post(
      PROJECT_PATH +
        SEND_BLANKBACK_PROJECT_PATH +
        `?blankId=${blankId}&emailToken=${emailToken}`,
    );
  };
  sendBlankDone = async ({ blankId, emailToken }) => {
    return await $apiPublic.post(
      PROJECT_PATH +
        SEND_BLANK_DONE_PROJECT_PATH +
        `?blankId=${blankId}&emailToken=${emailToken}`,
    );
  };
  findAllMaterialsForProject = async (
    page = 1,
    searchValue,
    projectId = "",
    limit = 10,
  ) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_ALL_MATERIALS_BLANK +
        `?page=${page}&search=${searchValue}&limit=${limit}&projectId=${projectId}`,
    );
  };
  getTableMaterialsForProject = async ({ projectId = "" }) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_TABLE_MATERIALS_PROJECT_PATH +
        `?projectId=${projectId}`,
    );
  };
  deleteBlank = async ({ projectId, blankId }) => {
    return await $apiPrivate.delete(
      PROJECT_PATH +
        DELETE_BLANK_PROJECT_PATH +
        `?blankId=${blankId}&projectId=${projectId}`,
    );
  };
  findLastUsersToBlank = async (projectId) => {
    return await $apiPrivate.get(
      PROJECT_PATH +
        GET_LAST_USERS_BLANK_PROJECT_PATH +
        `?projectId=${projectId}`,
    );
  };
}

export default new ProjectApi();
